/**
 * Бинарный кадр PCM между Meet и meet-noise-filter.
 *
 * Little-endian: uint32 seq, uint32 sampleRate, затем int16 mono.
 * Seq клиент ставит сам, сервис его же возвращает — так меряем круг.
 */

const HEADER_BYTES = 8

/**
 * Упаковывает один кадр микрофона в ArrayBuffer для WebSocket.
 */
export function encodePcmFrame(seq: number, sampleRate: number, samples: Int16Array): ArrayBuffer {
  const buffer = new ArrayBuffer(HEADER_BYTES + samples.byteLength)
  const view = new DataView(buffer)

  view.setUint32(0, seq >>> 0, true)
  view.setUint32(4, sampleRate >>> 0, true)
  new Int16Array(buffer, HEADER_BYTES).set(samples)

  return buffer
}

/**
 * Разбирает кадр с сервиса. Бросает, если заголовок обрезан.
 */
export function decodePcmFrame(data: ArrayBuffer): {
  seq: number
  sampleRate: number
  samples: Int16Array
} {
  if (data.byteLength < HEADER_BYTES) {
    throw new Error('pcm frame shorter than header')
  }

  const view = new DataView(data)
  const seq = view.getUint32(0, true)
  const sampleRate = view.getUint32(4, true)
  const samples = new Int16Array(data.slice(HEADER_BYTES))

  return { seq, sampleRate, samples }
}

/**
 * Переводит float32 [-1, 1] в int16 тем же масштабом, что сервис.
 */
export function floatToI16(input: Float32Array): Int16Array {
  const out = new Int16Array(input.length)

  for (let i = 0; i < input.length; i += 1) {
    const clipped = Math.max(-1, Math.min(1, input[i] ?? 0))
    const scaled = clipped * 32768

    out[i] = Math.max(-32768, Math.min(32767, scaled < 0 ? Math.ceil(scaled) : Math.floor(scaled)))
  }

  return out
}

/**
 * Переводит int16 с сервиса обратно во float32 для AudioWorklet.
 */
export function i16ToFloat(input: Int16Array): Float32Array {
  const out = new Float32Array(input.length)

  for (let i = 0; i < input.length; i += 1) {
    out[i] = (input[i] ?? 0) / 32768
  }

  return out
}
